module.exports = __webpack_public_path__ + "static/img/salon_question_zh-3.2a19ddd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/salon_question_zh-3.png
// module id = dd6L
// module chunks = 34